import { render, staticRenderFns } from "./AddUserWizardControl.global.vue?vue&type=template&id=314774f8&lang=pug&"
import script from "./AddUserWizardControl.global.vue?vue&type=script&lang=ts&"
export * from "./AddUserWizardControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports